import { Component, Input, OnInit, HostListener } from '@angular/core';
import { SearchModal } from 'src/app/core/services/search-modal.service';
import { ChatService } from 'src/app/core/services/chat.service';
import { RouterModule } from '@angular/router';
import { MenuLinkComponent } from '../menu-link/menu-link.component';
import { CommonModule } from '@angular/common';
import { SearchModalComponent } from '../search-modal/search-modal.component';
import { BaseComponent } from '../base/base.component';
import { takeUntil } from 'rxjs';
import { ClickOutsideDirective } from 'src/app/core/directives/click-outtside.directive';
import { CommonService } from 'src/app/core/services/common.service';

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.less'],
  standalone: true,
  imports: [RouterModule, MenuLinkComponent, CommonModule, SearchModalComponent, ClickOutsideDirective],
})
export class NavMenuComponent extends BaseComponent implements OnInit {
  @Input() public items!: any;
  @Input() isSearchEnable = false;
  @Input() phoneNumber:any = "";
  @Input() contactUsLinkTitle:any = "";
  @Input() contactUsLink:any = "";
  @Input() contactUsChat:any = "";
  @Input() isChatLoaded = false;
  @Input() public searchItems!: any;
  isChatInitialized = false;
  activeItem: any;
  isSearchOpen = false;
  isDesktop = false;


  @HostListener('document:click', ['$event']) onDocumentClick(event: any) {
    if (!event.target.closest('.nav-menu-item')) {
      this.activeItem = '';
    }
  }

  @HostListener('document:keyup', ['$event']) onKeyUpEvent(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      this.activeItem = ''; 
      this.isSearchOpen = false;
    }
  }

  constructor(private searchService: SearchModal, private chatService: ChatService, private commonService: CommonService) {
    super();
  }
  
  ngOnInit(): void {
    
    this.searchService.watch().pipe(takeUntil(this.destroy$)).subscribe((state: boolean) => {
      this.isSearchOpen = state;
    });

    this.chatService.chatWidgetLoaded$.pipe(takeUntil(this.destroy$)).subscribe(data => {
      if(data!==null){
        this.isChatLoaded = data;
      }
    })

    this.commonService.desktopUp$.pipe(takeUntil(this.destroy$)).subscribe(isDeskTopUp => {
        this.isDesktop = isDeskTopUp;
        this.commonService.updateLinkTabIndex(isDeskTopUp ? 0 : -1, '.nav-menu .menu-link', 1000);
    });
  }

  setActiveItem(item?: any, container?: HTMLElement) {
    this.activeItem = item;
    this.commonService.updateLinkTabIndex(this.isDesktop ? 0 : -1, '.nav-menu .menu-link');
    if (!this.activeItem) return;

    if (this.commonService.isPlatformBrowser()) {
      setTimeout(() => {
        container.querySelectorAll('.menu-link').forEach((link: HTMLElement) => {
          link.setAttribute('tabindex', '0');
        });
      }, 20);
    }
    
  }

  openSearchBox() {
    if (this.isSearchOpen) {
      this.searchService.close();
    } else {
      this.searchService.open();
    }
  }

  closeMenu() {
    this.activeItem = '';
  }

  triggerChat() {
    this.chatService.chatButtonClick.next(true);
  }
}
